
import Unipage from "../templates/Unipage";


export default function PrivacyPolicy() {
	document.title = "Privacy Policy - Img2pdf";

	return (
		<Unipage
			content={
				<>
					<h1>Privacy Policy</h1>
					<p>
						This website uses Google Analytics, which may collect certain information about you and set cookies for the purpose of recording your web-browsing behavior. See the Google <a href="https://policies.google.com/">Privacy & Terms</a> page for more info.
					</p>
					
					<p>
						This website does not knowingly record any other information about you.
					</p>
					<p>
						No files are transmitted to or stored on our servers. Instead the server sends code to your web browser that can be used to convert image files to PDF. All file conversion is client-side.
					</p>
					<p>
						This Privacy Policy is subject to change without notice.
					</p>
				</>
			}
		/>
	);
}